import * as yup from "yup";

export default function YupSchemaCreator(schema, config) {
  const { uniqueId, validationType, validations = [] } = config;

  if (!yup[validationType]) {
    return schema;
  }
  let validator = yup[validationType]();
  validations.forEach((validation) => {
    const { params, type } = validation;
    if (!validator[type]) {
      return;
    }

    validator = validator[type](...params);
  });
  schema[uniqueId] = validator;
  return schema;
}
